var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 125,
    viewBox: "0 0 89 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.167 1H3.36302C2.05796 1 1 3.02097 1 5.51397V119.486C1 121.979 2.05796 124 3.36302 124H86.167C87.472 124 88.53 121.979 88.53 119.486V5.51397C88.53 3.02097 87.472 1 86.167 1Z",
    stroke: "#733FE7",
    strokeWidth: 0.665095,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7228 10.5293H79.0309C80.0917 10.5293 80.9517 12.2372 80.9517 14.3439V110.658C80.9517 112.765 80.0917 114.473 79.0309 114.473H11.7228C10.662 114.473 9.80202 112.765 9.80202 110.658V14.3439C9.80202 12.2372 10.662 10.5293 11.7228 10.5293Z",
    stroke: "#733FE7",
    strokeWidth: 2.94976,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8706 61.6328H72.8832",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6724 29.585L61.8804 29.585",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8706 41.7109L72.8832 41.7109",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3398 24.3867H58.9464",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8706 49.5068H72.8832",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8706 85.0215H72.8832",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8706 72.8936H72.8832",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9443 102.345L72.8834 102.345",
    stroke: "#733FE7",
    strokeWidth: 1.82901,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.608,
    y1: 49.5068,
    x2: 18.608,
    y2: 85.0209,
    stroke: "#733FE7",
    strokeWidth: 1.47488
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5446,
    y1: 49.5068,
    x2: 32.5446,
    y2: 85.0209,
    stroke: "#733FE7",
    strokeWidth: 1.47488
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 58.2169,
    y1: 49.5068,
    x2: 58.2169,
    y2: 85.0209,
    stroke: "#733FE7",
    strokeWidth: 1.47488
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 72.1535,
    y1: 49.5068,
    x2: 72.1535,
    y2: 85.0209,
    stroke: "#733FE7",
    strokeWidth: 1.47488
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfp);
export default __webpack_public_path__ + "static/media/afp.2bfc8f14.svg";
export { ForwardRef as ReactComponent };